exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".chat__chat___32TtU {\n  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.75);\n  background: #FFFFFF;\n  border-radius: 6px;\n  margin-left: 4px;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column; }\n  .chat__chat___32TtU .chat__noChatSelected___1QUaI {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1.2rem;\n    flex-grow: 1;\n    text-align: center;\n    color: #6b6767; }\n    .chat__chat___32TtU .chat__noChatSelected___1QUaI span {\n      width: 80%; }\n  .chat__chat___32TtU .chat__sendMessageWrapper___12tdF {\n    background: #4fd0b3;\n    border-radius: 0 0 6px 6px; }\n    .chat__chat___32TtU .chat__sendMessageWrapper___12tdF input {\n      padding: 10px;\n      margin: 10px;\n      border-radius: 5px;\n      outline: none;\n      border: none;\n      width: 70%; }\n", ""]);

// exports
exports.locals = {
	"chat": "chat__chat___32TtU",
	"noChatSelected": "chat__noChatSelected___1QUaI",
	"sendMessageWrapper": "chat__sendMessageWrapper___12tdF"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/containers/Chat/chat.scss
// module id = 890
// module chunks = 0